const MILLISECONDS_PER_HOUR = 60 * 60 * 1000;
const MILLISECONDS_PER_DAY = 24 * MILLISECONDS_PER_HOUR;

export { MILLISECONDS_PER_DAY, MILLISECONDS_PER_HOUR };
